/**
 * Camera mixin
 *
 * Добавляет логику для работы с камерой: запуск, фото/видео запись
 *
 */

import { FaceType } from '@pb/api/dist/src/services/face_recognize';

export default {
  staticData: () => ({
    videoRecordingTimeout: null,
    prolongInteractionInterval: null,
  }),
  created() {
    this.initCameraActions();
  },
  methods: {
    async startCamera(hasBorders = false) {
      try {
        await this.$robot.faceRecognizeService.enableBorders(hasBorders);
        await this.$robot.cameraService.startCamera();
      } catch (e) {
        this.onCameraError(e);
      }
    },
    stopCamera() {
      this.$robot.cameraService.stopCamera();
    },
    async takePhoto() {
      try {
        const mimeType = 'image/png';
        const fullpath = await this.$robot.cameraService.makePhoto();
        const filename = fullpath.split('/home/promobot/').pop();
        const base64 = await this.$robot.filesystemService.loadFile(mimeType, filename);
        const original = base64;
        this.onPhotoReady?.({
          mimeType, original, base64, fullpath,
        });
      } catch (e) {
        this.onCameraError(e);
      }
    },
    savePhoto(photo) {
      const { mimeType, base64, fullpath } = photo;
      return this.$robot.filesystemService.saveFile(mimeType, base64, fullpath);
    },
    async startVideoRecording(timeout = 0) {
      try {
        this.$robot.dialogService.abortRobotReplic();
        this.$robot.dialogService.muteOn();
        await this.$axios.get(process.env.VUE_APP_VIDEO_START_RECORDING);
        if (timeout > 0) {
          this.setVideoRecordingTimeout(timeout * 1000);
        }
        this.onVideoRecordStart?.();
        this.setProlongInteractionInterval();
      } catch (e) {
        this.onCameraError(e);
      }
    },
    async stopVideoRecording() {
      try {
        this.clearProlongInteractionInterval();
        this.$robot.dialogService.muteOff();
        this.onVideoRecordStop?.();
        const { data } = await this.$axios.get(process.env.VUE_APP_VIDEO_STOP_RECORDING);
        const fullpath = data.filename;
        this.onVideoReady?.({ fullpath });
      } catch (e) {
        this.onCameraError(e);
      }
    },
    playVideoRecording(video) {
      if (!video) {
        console.error('Start playing without video!');
        return;
      }
      const url = video.fullpath.split('/home/promobot/Videos/').pop();
      this.$robot.dialogService.sayReplicByData({ text: '', url }, true);
    },
    onCameraStart() {
      // onCameraStart
    },
    onCameraError(e) {
      console.error('onCameraError: ', e);
    },
    setVideoRecordingTimeout(timeout) {
      this.videoRecordingTimeout = window.setTimeout(this.stopVideoRecording, timeout);
    },
    clearVideoRecordingTimeout() {
      window.clearTimeout(this.videoRecordingTimeout);
    },
    setProlongInteractionInterval() {
      // хак для автоматического продления взаимодействия при записи видео
      this.prolongInteractionInterval = window.setInterval(this.prolongInteraction, 5000);
    },
    clearProlongInteractionInterval() {
      window.clearInterval(this.prolongInteractionInterval);
    },
    prolongInteraction() {
      const facesInfo = this.$robot.faceRecognizeService.getInfo();
      const faces = facesInfo.filter((face) => face.type > FaceType.None); // все лица (распознанные и нет)
      if (faces.length) {
        this.$robot.interactionService.start();
      }
    },
    initCameraActions() {
      const robotActions = [
        this.$robot.cameraService.onCameraStart(this.onCameraStart),
        this.$robot.cameraService.onCameraError(this.onCameraError),
      ];
      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
        this.clearProlongInteractionInterval();
        this.clearVideoRecordingTimeout();
        this.stopVideoRecording();
        this.stopCamera();
      });
    },
  },
};
